<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col md="3" cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Others Info</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form
                  @submit.prevent="submitForm(currentStatus)"
                  ref="addLcImportPi"
                  id="addLcImportPi"
                >
                  <v-row class="pa-2">
                    <v-col cols="12">
                      <v-text-field
                        label="PI No"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="pi_no.value.value"
                        :error-messages="pi_no.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          PI No
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>

                      <v-date-input
                        label="PI Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="pi_date.value.value"
                        :error-messages="pi_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="supplier_id.value.value"
                        :items="getSupplierList"
                        :item-title="(item) => `${item.supplier_name}`"
                        item-value="id"
                        :error-messages="supplier_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Supplier Name
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      
                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="currency_id.value.value"
                        :items="getCurrencyList"
                        :item-title="(item) => `${item.code} - ${item.name}`"
                        item-value="id"
                        :error-messages="currency_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Currency
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>


                      
                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="incoterm_id.value.value"
                        :items="getLcIncotermList"
                        :item-title="(item) => `${item.code} - ${item.name}`"
                        item-value="id"
                        :error-messages="incoterm_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Incoterm
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="payment_term_id.value.value"
                        :items="getLcPaymentTermList"
                        :item-title="(item) => `${item.code} - ${item.name}`"
                        item-value="id"
                        :error-messages="payment_term_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Payment Term
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>
                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="loading_port_id.value.value"
                        :items="getLcPortList"
                        :item-title="(item) => `${item.code} - ${item.name}`"
                        item-value="id"
                        :error-messages="loading_port_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Loading Port
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="discharge_port_id.value.value"
                        :items="getLcPortList"
                        :item-title="(item) => `${item.code} - ${item.name}`"
                        item-value="id"
                        :error-messages="discharge_port_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Discharge Port
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="shipping_method_id.value.value"
                        :items="getLcShippingMethodList"
                        :item-title="(item) => `${item.code} - ${item.name}`"
                        item-value="id"
                        :error-messages="shipping_method_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Shipping Method
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="bank_id.value.value"
                        :items="getLcBankList"
                        :item-title="(item) => `${item.code} - ${item.name}`"
                        item-value="id"
                        :error-messages="bank_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Bank
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>


                      <v-date-input
                        label="Validity"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="validity.value.value"
                        :error-messages="validity.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>

                      <v-textarea
                        label="Remarks"
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="remarks.value.value"
                        :error-messages="remarks.errorMessage.value"
                        autocomplete="off"
                        rows="3"
                        clearable
                      ></v-textarea>

                      <input
                        v-model="pi_master_id.value.value"
                        type="hidden"
                      />
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <v-col md="9" cols="12">
          <v-expansion-panels v-model="panel2">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Item Info</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form
                  @submit.prevent="submitForm(currentStatus)"
                  ref="addLcImportPi"
                  id="addLcImportPi"
                >
                  <v-row class="pt-2 justify-center">
                    <v-col cols="8">
                      <v-autocomplete
                        label="Search Product Name"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="product_id.value.value"
                        :items="getProductMapList"
                        :item-title="(item) => `${item.product.code}-${item.product.name}` ?? 'N/A'"
                        item-value="product_id"
                        :error-messages="product_id.errorMessage.value"
                        @update:model-value="addCart"
                        @keydown.enter="addCart"
                        autocomplete="off"
                        clearable
                      ></v-autocomplete>
                    </v-col>

                    <!-- <v-col cols="1">
                      <v-btn class="bg-primary" @click="addCart">ADD</v-btn>
                    </v-col> -->
                  </v-row>

                  <!-- Cart Table -->
                  <v-row class="pt-0">
                    <v-col cols="12">
                      <v-table
                        density="compact"
                        :loading="loading"
                        fixed-header
                        class="table-dotted-border-bottom"
                      >
                        <thead>
                          <tr>
                            <th class="text-center" style="width: 5%">SL</th>
                            <th class="text-left" style="width: 30%">Product Name</th>
                            <th class="text-center" style="width: 10%">Code</th>
                            <th class="text-center" style="width: 10%">Quantity</th>
                            <th class="text-center" style="width: 15%">Rate</th>
                            <th class="text-center" style="width: 15%">Amount</th>
                            <th class="text-right" style="width: 5%">Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr
                            v-for="(item, index) in cart"
                            v-if="cart.length > 0"
                            :key="index"
                          >
                            <td class="text-center py-1">{{ index + 1 }}</td>
                            <td class="text-left py-1" style="white-space: normal">
                              {{ item.product_name }}
                            </td>
                            <td class="text-left py-1" style="white-space: normal">
                              {{ item.product_code }}
                            </td>
                            <td class="text-right py-2">
                              <v-text-field
                                style="width: 80px"
                                label=""
                                :min="0.1"
                                type="number"
                                step="0.01"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="item.qty"
                                hide-details
                                :error="item.qty < 0.1"
                                :error-messages="
                                  item.qty < 0.1
                                    ? 'Quantity must be greater than 0'
                                    : ''
                                "
                                @update:model-value="
                                  item.total = item.qty * item.rate
                                "
                                @blur="item.total = item.qty * item.rate"
                              ></v-text-field>
                            </td>
                            <td class="text-right py-2">
                              <v-text-field
                                style="width: 100px"
                                label=""
                                :min="0.1"
                                type="number"
                                step="0.01"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="item.rate"
                                hide-details
                                :error="item.rate < 0.1"
                                :error-messages="
                                  item.rate < 0.1
                                    ? 'Rate must be greater than 0'
                                    : ''
                                "
                                @update:model-value="
                                  item.total = item.qty * item.rate
                                "
                                @blur="item.total = item.qty * item.rate"
                              ></v-text-field>
                            </td>
                            <td class="text-center py-1">
                              {{ this.$numberFormat(item.total) }}
                            </td>
                            <td class="text-center py-1">
                              <v-icon
                                size="small"
                                color="red"
                                class="delete-button"
                                @click="removeFromCart(index)"
                              >
                                mdi-delete
                              </v-icon>
                            </td>
                          </tr>
                          <tr v-if="cart.length === 0">
                            <td colspan="7" class="text-center text-red">
                              You have no item
                            </td>
                          </tr>
                        </tbody>
                        <tfoot v-if="cart.length > 0">
                          <tr>
                            <td colspan="4" class="text-right py-1">
                              Total Amount
                            </td>
                            <td colspan="2" class="text-center py-1">
                              {{ this.$numberFormat(totalAmount) }}
                            </td>
                            <td></td>
                          </tr>
                        </tfoot>
                      </v-table>
                    </v-col>
                  </v-row>

                  <v-divider class="my-4"></v-divider>
                  <v-row class="pt-0">
                    <v-col cols="12">
                      <div class="d-flex justify-end" style="gap: 12px;">
                        <v-btn
                          class="bg-grey-darken-1"
                          variant="flat"
                          type="button"
                          :loading="loading && currentStatus === 0"
                          :disabled="loading && currentStatus !== 0"
                          @click="submitForm(0)"
                        >
                          DRAFT
                        </v-btn>
                        <v-btn
                          class="bg-primary"
                          variant="flat"
                          type="button"
                          :loading="loading && currentStatus === 1"
                          :disabled="loading && currentStatus !== 1"
                          @click="submitForm(1)"
                        >
                          POST
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import formattedDate from "@/plugins/dateFormatter";
import { useField, useForm } from "vee-validate";
import { getCurrentInstance, ref, computed, onMounted, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { toast } from "vue3-toastify";
import { useStore } from "vuex";
import * as yup from "yup";

export default {
  components: {},
  data: () => ({
    panel: [0],
    panel2: [0],
    loading: false,
    cart: [],
  }),
  setup() {
    const { proxy } = getCurrentInstance();
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        pi_no: yup.string().required().label("PI No"),
        pi_date: yup.date().required().label("PI Date"),
        supplier_id: yup.number().positive().integer().required().label("Supplier"),
        currency_id: yup.number().positive().integer().required().label("Currency"),
        incoterm_id: yup.number().positive().integer().required().label("Incoterm"),
        loading_port_id: yup.number().positive().integer().required().label("Loading Port"),
        discharge_port_id: yup.number().positive().integer().required().label("Discharge Port"),
        shipping_method_id: yup.number().positive().integer().required().label("Shipping Method"),
        bank_id: yup.number().positive().integer().required().label("Bank"),
        payment_term_id: yup.number().positive().integer().required().label("Payment Term"),
        validity: yup.date().nullable().label("Validity"),
      }),
    });

    const pi_master_id = useField("pi_master_id");
    const pi_no = useField("pi_no");
    const pi_date = useField("pi_date");
    const supplier_id = useField("supplier_id");
    const currency_id = useField("currency_id");
    const incoterm_id = useField("incoterm_id");
    const payment_term_id = useField("payment_term_id");
    const loading_port_id = useField("loading_port_id");
    const discharge_port_id = useField("discharge_port_id");
    const shipping_method_id = useField("shipping_method_id");
    const bank_id = useField("bank_id");
    const validity = useField("validity");
    const remarks = useField("remarks");
    const product_id = useField("product_id");
    const status = useField("status");

    const errorMessages = ref("");
    const cart = ref([]);
    const loading = ref(false);
    const buttonText = ref("Save");
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const currentStatus = ref(0);

    const totalAmount = computed(() => {
      return cart.value.reduce((sum, item) => +sum + +item.total, 0);
    });

    const branchId = computed(() => {
      return store.getters.getAuthUser?.branch_id || null;
    });

    const getSupplierList = computed(() => {
      return store.getters.getSupplierList || [];
    });

    const getCurrencyList = computed(() => {
      return store.getters.getCurrencyList || [];
    });

    const getLcIncotermList = computed(() => {
      return store.getters.getLcIncotermList || [];
    });

    const getLcPaymentTermList = computed(() => {
      return store.getters.getLcPaymentTermList || [];
    });

    const getLcPortList = computed(() => {
      return store.getters.getLcPortList || [];
    });

    const getLcShippingMethodList = computed(() => {
      return store.getters.getLcShippingMethodList || [];
    });

    const getLcBankList = computed(() => {
      return store.getters.getLcBankList || [];
    });

    const getProductMapList = computed(() => {
      let products = store.getters.getProductMapList || [];
      return products.filter(
        (item) => item.branch_id == branchId.value && item.status == 1
      );
    });

    const loadPiData = async (id) => {
      if (!id) {
        // Clear form for new entry
        pi_master_id.value.value = null;
        pi_no.value.value = "";
        pi_date.value.value = null;
        supplier_id.value.value = null;
        currency_id.value.value = null;
        incoterm_id.value.value = null;
        payment_term_id.value.value = null;
        loading_port_id.value.value = null;
        discharge_port_id.value.value = null;
        shipping_method_id.value.value = null;
        bank_id.value.value = null;
        validity.value.value = null;
        remarks.value.value = "";
        cart.value = [];
        return;
      }

      loading.value = true;
      try {
        const data = await store.dispatch("getLcImportPiById", id);
        pi_master_id.value.value = data.id;
        pi_no.value.value = data.pi_no;
        pi_date.value.value = data.pi_date;
        supplier_id.value.value = data.supplier_id;
        currency_id.value.value = data.currency_id;
        incoterm_id.value.value = data.incoterm_id;
        payment_term_id.value.value = data.payment_term_id;
        loading_port_id.value.value = data.loading_port_id;
        discharge_port_id.value.value = data.discharge_port_id;
        shipping_method_id.value.value = data.shipping_method_id;
        bank_id.value.value = data.bank_id;
        validity.value.value = data.validity;
        remarks.value.value = data.remarks;

        cart.value = (data.details || []).map((item) => ({
          product_id: item.product_id,
          product_name: item.product?.name || "",
          product_code: item.product?.code || "",
          qty: item.qty,
          rate: item.rate,
          total: item.amount || item.qty * item.rate,
        }));
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to load PI data");
      } finally {
        loading.value = false;
      }
    };

    onMounted(async () => {
      // Load initial data
      if (store.getters.getSupplierList.length === 0) {
        await store.dispatch("getSupplierList", {});
      }
      if (store.getters.getCurrencyList.length === 0) {
        await store.dispatch("getCurrencyList");
      }
      if (store.getters.getLcIncotermList.length === 0) {
        await store.dispatch("getLcIncotermList");
      }
      if (store.getters.getLcPaymentTermList.length === 0) {
        await store.dispatch("getLcPaymentTermList");
      }
      if (store.getters.getLcPortList.length === 0) {
        await store.dispatch("getLcPortList");
      }
      if (store.getters.getLcShippingMethodList.length === 0) {
        await store.dispatch("getLcShippingMethodList");
      }
      if (store.getters.getLcBankList.length === 0) {
        await store.dispatch("getLcBankList");
      }
      if (store.getters.getProductMapList.length === 0) {
        await store.dispatch("getProductMapList", {});
      }

      // Load for edit
      if (route.params.id) {
        await loadPiData(route.params.id);
      }
    });

    // Watch for route changes to handle navigation between create and edit
    watch(
      () => route.params.id,
      (newId) => {
        loadPiData(newId);
      },
      { immediate: false }
    );

    const addCart = () => {
      if (!product_id.value.value) {
        toast.error("Please select a Product");
        product_id.value.value = null;
        return false;
      }

      let cartInd = cart.value.findIndex(
        (p) => p.product_id == product_id.value.value
      );
      if (cartInd > -1) {
        toast.error("Product already added in cart");
        product_id.value.value = null;
        return false;
      }

      let product = getProductMapList.value.find(
        (item) => item.product_id == product_id.value.value
      );
      product = product.product;

      let item = {
        product_id: product_id.value.value,
        product_name: product.name,
        product_code: product.code,
        qty: 1,
        rate: product.purchase_rate || 0,
        total: product.purchase_rate || 0,
      };

      cart.value.push(item);
      product_id.value.value = null;
    };

    const removeFromCart = (index) => {
      if (confirm("Are You Sure?")) {
        cart.value.splice(index, 1);
      }
    };

    const submitForm = (btnStatus) => {
      currentStatus.value = btnStatus;
      status.value.value = btnStatus;

      if (cart.value.length === 0) {
        toast.error("Please add at least one product");
        return;
      }

      submit();
    };

    const submit = handleSubmit(async (values) => {
      loading.value = true;
      try {
        const data = {
          pi_master_id: pi_master_id.value.value || null,
          pi_no: pi_no.value.value,
          pi_date: formattedDate(pi_date.value.value),
          supplier_id: supplier_id.value.value,
          currency_id: currency_id.value.value,
          incoterm_id: incoterm_id.value.value,
          payment_term_id: payment_term_id.value.value,
          loading_port_id: loading_port_id.value.value,
          discharge_port_id: discharge_port_id.value.value,
          shipping_method_id: shipping_method_id.value.value,
          bank_id: bank_id.value.value,
          validity: validity.value.value ? formattedDate(validity.value.value) : null,
          remarks: remarks.value.value || null,
          status: status.value.value,
          total_amount: totalAmount.value,
          details: cart.value.map((item) => ({
            product_id: item.product_id,
            qty: parseFloat(item.qty),
            rate: parseFloat(item.rate),
          })),
        };

        await store.dispatch("saveUpdateLcImportPi", data);
        toast.success("PI saved successfully");
        router.push({ path: "/lc/import-pi-record" });
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to save PI");
      } finally {
        loading.value = false;
      }
    });

    return {
      pi_master_id,
      pi_no,
      pi_date,
      supplier_id,
      currency_id,
      validity,
      incoterm_id,
      payment_term_id,
      loading_port_id,
      discharge_port_id,
      shipping_method_id,
      bank_id,
      remarks,
      product_id,
      status,
      errorMessages,
      cart,
      loading,
      buttonText,
      currentStatus,
      totalAmount,
      branchId,
      getSupplierList,
      getCurrencyList,
      getLcIncotermList,
      getLcPaymentTermList,
      getLcPortList,
      getLcShippingMethodList,
      getLcBankList,
      getProductMapList,
     
      addCart,
      removeFromCart,
      submitForm,
    };
  },
};
</script>

